/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppointmentApiResponse } from '../../models/appointment-api-response';
import { CreateAppointmentRequest } from '../../models/create-appointment-request';

export interface CreateAppointment$Json$Params {
  
    /**
     * The appointment details
     */
    body?: CreateAppointmentRequest
}

export function createAppointment$Json(http: HttpClient, rootUrl: string, params?: CreateAppointment$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AppointmentApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createAppointment$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppointmentApiResponse>;
    })
  );
}

createAppointment$Json.PATH = '/api/Calendar/appointments';
